exports.connect = {
	url: "https://api.campingdelabaie.camp/"
}
